var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOpacity = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 13.3333V6.66667C2.5 4.36548 4.36548 2.5 6.66667 2.5H13.3333C15.6345 2.5 17.5 4.36548 17.5 6.66667V13.3333C17.5 15.6345 15.6345 17.5 13.3333 17.5H6.66667C4.36548 17.5 2.5 15.6345 2.5 13.3333Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25004 11.2084C6.27305 11.2084 6.29171 11.227 6.29171 11.25C6.29171 11.2731 6.27305 11.2917 6.25004 11.2917C6.22703 11.2917 6.20837 11.2731 6.20837 11.25C6.20837 11.227 6.22703 11.2084 6.25004 11.2084",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25004 8.70837C6.27305 8.70837 6.29171 8.72703 6.29171 8.75004C6.29171 8.77305 6.27305 8.79171 6.25004 8.79171C6.22703 8.79171 6.20837 8.77305 6.20837 8.75004C6.20837 8.72703 6.22703 8.70837 6.25004 8.70837",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25004 6.20837C6.27305 6.20837 6.29171 6.22703 6.29171 6.25004C6.29171 6.27305 6.27305 6.29171 6.25004 6.29171C6.22703 6.29171 6.20837 6.27305 6.20837 6.25004C6.20837 6.22703 6.22703 6.20837 6.25004 6.20837",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8.75004 6.20837C8.77305 6.20837 8.79171 6.22703 8.79171 6.25004C8.79171 6.27305 8.77305 6.29171 8.75004 6.29171C8.72703 6.29171 8.70837 6.27305 8.70837 6.25004C8.70837 6.22703 8.72703 6.20837 8.75004 6.20837",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8.75004 8.70837C8.77305 8.70837 8.79171 8.72703 8.79171 8.75004C8.79171 8.77305 8.77305 8.79171 8.75004 8.79171C8.72703 8.79171 8.70837 8.77305 8.70837 8.75004C8.70837 8.72703 8.72703 8.70837 8.75004 8.70837",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8.75004 11.2084C8.77305 11.2084 8.79171 11.227 8.79171 11.25C8.79171 11.2731 8.77305 11.2917 8.75004 11.2917C8.72703 11.2917 8.70837 11.2731 8.70837 11.25C8.70837 11.227 8.72703 11.2084 8.75004 11.2084",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8.75004 13.7084C8.77305 13.7084 8.79171 13.727 8.79171 13.75C8.79171 13.7731 8.77305 13.7917 8.75004 13.7917C8.72703 13.7917 8.70837 13.7731 8.70837 13.75C8.70837 13.727 8.72703 13.7084 8.75004 13.7084",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.25 6.20837C11.2731 6.20837 11.2917 6.22703 11.2917 6.25004C11.2917 6.27305 11.2731 6.29171 11.25 6.29171C11.227 6.29171 11.2084 6.27305 11.2084 6.25004C11.2084 6.22703 11.227 6.20837 11.25 6.20837",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.25 8.70837C11.2731 8.70837 11.2917 8.72703 11.2917 8.75004C11.2917 8.77305 11.2731 8.79171 11.25 8.79171C11.227 8.79171 11.2084 8.77305 11.2084 8.75004C11.2084 8.72703 11.227 8.70837 11.25 8.70837",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.25 11.2084C11.2731 11.2084 11.2917 11.227 11.2917 11.25C11.2917 11.2731 11.2731 11.2917 11.25 11.2917C11.227 11.2917 11.2084 11.2731 11.2084 11.25C11.2084 11.227 11.227 11.2084 11.25 11.2084",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.25 13.7084C11.2731 13.7084 11.2917 13.727 11.2917 13.75C11.2917 13.7731 11.2731 13.7917 11.25 13.7917C11.227 13.7917 11.2084 13.7731 11.2084 13.75C11.2084 13.727 11.227 13.7084 11.25 13.7084",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25004 13.7917C6.22703 13.7917 6.20837 13.7731 6.20837 13.75C6.20837 13.727 6.22703 13.7084 6.25004 13.7084C6.27305 13.7084 6.29171 13.727 6.29171 13.75C6.29171 13.7731 6.27305 13.7917 6.25004 13.7917",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOpacity);
export default ForwardRef;